export const MAX_JS_NUMBER_LENGTH = 15;
